<script>
import CommonSubtitle from "../../CommonSubtitle/index.vue";
import DanInfo from "./DanInfo.vue";
import AddressInfo from "./AddressInfo.vue";
import BankAccountInfo from "./BankAccountInfo.vue";
import CustomButton from "../../CustomButton/index.vue";
import ConfirmTabs from "../ConfirmTabs.vue";
import DisabilityInfo from "./DisabilityInfo.vue";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import { createUser } from "../../../api/user";
import { mapActions, mapState } from "vuex";

export default {
  name: "PersonalInfo",
  components: {
    DisabilityInfo,
    ConfirmTabs,
    CustomButton,
    BankAccountInfo,
    AddressInfo,
    DanInfo,
    CommonSubtitle,
  },
  data() {
    return {
      loading: false,
      submitted: false,
      formData: {
        danInfo: {
          middlename: "",
          lastname: "",
          firstname: "",
          register_number: "",
          civil_id: "",
          birthday: "",
          sex: "",
          dan_verified: 1,
          passport_expire_date: "",
        },
        disabilityInfo: {
          is_disabled: false,
          disability: "",
          percent: null,
          start_date: null,
          end_date: null,
        },
        addressInfo: {
          address_type: "ID",
          country: "496",
          city: "",
          district: "",
          khoroo: "",
          apartment: "",
          current_city: "",
          current_district: "",
          current_khoroo: "",
          current_apartment: "",
          same_address: false,
        },
        bankAccountInfo: {
          bank_name: "",
          account_number: "",
          bank_account_holder: "",
        },
      },
    };
  },
  validations() {
    const isDisabled = () => !!this.formData.disabilityInfo.is_disabled;
    const isNotSameAddress = () => !this.formData.addressInfo.same_address;
    const requiresManualProfile = () => this.isChildUser;
    return {
      formData: {
        danInfo: {
          firstname: {
            required: requiredIf(requiresManualProfile),
          },
          lastname: {
            required: requiredIf(requiresManualProfile),
          },
          register_number: {
            required: requiredIf(requiresManualProfile),
          },
          birthday: {
            required: requiredIf(requiresManualProfile),
          },
          sex: {
            required: requiredIf(requiresManualProfile),
          },
        },
        disabilityInfo: {
          is_disabled: { required },
          percent: {
            required: requiredIf(isDisabled),
            between: (value) => value >= 0 && value <= 100,
          },
          disability: {
            required: requiredIf(isDisabled),
          },
          start_date: {
            required: requiredIf(isDisabled),
          },
          end_date: {
            required: requiredIf(isDisabled),
          },
        },
        addressInfo: {
          city: required,
          district: required,
          khoroo: required,
          apartment: required,
          current_city: {
            required: requiredIf(isNotSameAddress),
          },
          current_district: {
            required: requiredIf(isNotSameAddress),
          },
          current_khoroo: {
            required: requiredIf(isNotSameAddress),
          },
          current_apartment: {
            required: requiredIf(isNotSameAddress),
          },
        },
        bankAccountInfo: {
          bank_name: { required },
          account_number: { required },
          bank_account_holder: { required },
        },
      },
    };
  },
  setup() {
    const v$ = useVuelidate();
    return { v$ };
  },
  computed: {
    ...mapState("user", ["user", "danState", "kycStatus"]),
    isChildUser() {
      return ["child", "children"].includes(this.user?.individual);
    },
    showPersonalInfoForm() {
      return (
        !!this.user?.mobilenumber &&
        (this.isChildUser ||
          !!this.user?.dan_verified ||
          !!this.user?.register_number ||
          this.danState)
      );
    },
  },
  methods: {
    async submitForm() {
      this.submitted = true;
      const isValid = await this.v$.$validate();
      if (isValid) {
        console.log("submitting form", this.formData);
        try {
          this.loading = true;
          // Дангаар баталгаажих үед харилцагчийг бүртгэж байгаа
          // const res = await createUser('profile', this.formData.danInfo)
          let currentAddress = {};
          if (this.formData.addressInfo.same_address) {
            currentAddress = {
              ...this.formData.addressInfo,
              address_type: "CURRENT",
            };
          } else {
            currentAddress["address_type"] = "CURRENT";
            currentAddress["city"] = this.formData.addressInfo.current_city;
            currentAddress["district"] =
              this.formData.addressInfo.current_district;
            currentAddress["khoroo"] = this.formData.addressInfo.current_khoroo;
            currentAddress["apartment"] =
              this.formData.addressInfo.current_apartment;
          }
          const promises = [
            createUser("address", this.formData.addressInfo),
            createUser("address", currentAddress),
            createUser("disability", this.formData.disabilityInfo),
          ];
          if (this.isChildUser) {
            promises.unshift(createUser("profile", this.formData.danInfo));
          }
          if (!this.kycStatus.bank_account) {
            promises.push(
              createUser("bank-account", this.formData.bankAccountInfo),
            );
          }
          await Promise.all(promises);
          this.loading = false;

          this.$bvToast.toast("Амжилттай мэдээлэл хадгаллаа", {
            title: "Амжилттай",
            variant: "success",
          });
          this.submitted = false;
          this.$emit("selectTab", this.isChildUser ? 4 : 2);
          await this.$store.dispatch("user/fetchUser");
        } catch (e) {
          this.loading = false;
          console.log(e);
        }
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <ConfirmTabs />
    <template v-if="showPersonalInfoForm">
      <DanInfo
        :dan-info="formData.danInfo"
        :v$="v$.formData.danInfo"
        :submitted="submitted"
        class="mb-4"
      />
      <DisabilityInfo
        :disability-info="formData.disabilityInfo"
        :v$="v$.formData.disabilityInfo"
        class="mb-4"
      />
      <AddressInfo
        :address-info="formData.addressInfo"
        :v$="v$.formData.addressInfo"
        :submitted="submitted"
        class="mb-4"
      />
      <BankAccountInfo
        :bank-account-info="formData.bankAccountInfo"
        :v$="v$.formData.bankAccountInfo"
        class="mb-4"
      />
      <div class="d-flex justify-content-center mt-xl-5">
        <ic-button
          class="card-button"
          size="tn"
          :loading="loading"
          @click="submitForm"
          >Хадгалах</ic-button
        >
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss"></style>
